import { SyntheticEvent } from 'react';

export const getNavClickHandler = (isActive: boolean) => (event: SyntheticEvent) => {
    if (isActive) {
        event.preventDefault();
    }
};
